import React, { useState } from "react";
import '../styles/navbar.scss';

const NavBar = (props: {
     brand: { name: string, to: string}
     links: Array<{ name: string; to: string}>
    }) => {
    const { brand, links } = props;
    const [open, setOpen] = useState(false);

    return (
        <nav id="scrollNav">
            <div className="nav-bar">
                <div className="welcome">{brand.name}</div>
                <button
                    type="button"
                    className={`nav-toggle${open ? ' is-open' : ''}`}
                    aria-label={open ? 'Close menu' : 'Open menu'}
                    aria-expanded={open}
                    onClick={() => setOpen((o) => !o)}
                >
                    <span />
                    <span />
                    <span />
                </button>
            </div>
            <ul className={`nav-links${open ? ' is-open' : ''}`}>
                {links.map((link) => (
                    <li className='liNav' key={link.name}>
                        {/* close the mobile menu after a link is tapped */}
                        <a href={link.to} onClick={() => setOpen(false)}>{link.name}</a>
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export default NavBar;
